export enum FilterType {
    user,
    date,
    partner,
    policyHolder,
    customerTag,
    callSource,
    callStatus,
    subscriptionStatus,
    credentialStatus,
    invoiceStatus,
    age,
    gender,
    country,
    switchedCalls,
    callDecision,
}

export interface Filter {
    key: FilterType
    label: string
    value?: any
    selected?: any
    dependsOn?: FilterType[]
}